import React, { useState } from "react";
import i18n from "i18next";
import Button from "~/Common-Objects/UI/Forms/Button/Button";
import DropDown from "~/Common-Objects/UI/DropDowns/DropDown";
import Icons from "~/Common-Objects/UI/Icons/index";

export default function AddContentButton({ onSelect }) {
  const [isAddOpen, setIsAddOpen] = useState(false);

  function handleSelect(type) {
    onSelect(type);
    setIsAddOpen(false);
  }

  return (
    <div>
      <Button
        className="button-primary"
        iconLeft={<Icons icon="plus" />}
        onClick={() => setIsAddOpen((prev) => !prev)}
      >
        {i18n.t("form:gated.empty.cta")}
      </Button>

      <DropDown
        className="select-gated-content__add-dropdown"
        isOpen={isAddOpen}
        onClose={() => setIsAddOpen(false)}
      >
        <ul>
          <li>
            <button onClick={() => handleSelect("file")}>
              <Icons icon="document" color="#969695" />{" "}
              {i18n.t("form:gated.add.file")}
            </button>
          </li>
          <li>
            <button onClick={() => handleSelect("link")}>
              <Icons icon="link" color="#969695" />{" "}
              {i18n.t("form:gated.add.link")}
            </button>
          </li>
        </ul>
      </DropDown>
    </div>
  );
}
